export default __webpack_public_path__ + "static/sql-dark-2a12e1de8094518953380caf0c898244.png";